/* eslint-disable react/prop-types */
import React, { useState } from "react"; // React Stuff
// Common
import SpecialRequirements from "../../common/SpecialRequirementsTooltip.js";
//TimeRendering
import Moment from "react-moment";
//Packages
import axios from "axios";
import { Col, Row, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

const BlockParticipants = (props) => {
  const [cancellingID, setCancellingID] = useState("");
  //Cancel the Subscription
  const cancelBooking = async (_id) => {
    const data = {
      participantID: _id,
      blockID: props.data._id,
    };
    const cancelRequest = await axios.delete(
      `/api/admin/manage_subscription/delete_block`,
      { data },
      {
        withCredentials: true,
      }
    );
    if (cancelRequest.status === 200) {
      props.setSubmitClicked(false);
      props.fetchNewData(); // Wait a moment for Stripe API to respond on the web hook.
      setCancellingID("");
      return props.setSuccessMessage("Removed.");
    } else {
      setCancellingID("");
      props.setSubmitClicked(false);
      return props.setErrorMessage("There was a problem with your request.");
    }
  };

  return (
    <Row className='mt-4 mb-4 text-center'>
      <Col className='border shadow p-3'>
        <h3 className='mt-4'>Bookings/Learners</h3>
        {props.data.Participants.length > 0 ? (
          <Table striped bordered hover responsive size='sm' className='text-center'>
            <thead>
              <tr>
                <th>Name</th>
                <th>Info</th>
                <th>Kick?</th>
              </tr>
            </thead>
            <tbody>
              {props.data.Participants.map((participant) => (
                <tr key={participant._id}>
                  <td className='align-self-center align-middle'>
                    <small>
                      <Link to={`/admin/customer-list/${participant.SystemUserID}`}>
                        {`${participant.First_Name} ${participant.Last_Name}`}
                      </Link>
                      {participant.Special_Requirements && (
                        <SpecialRequirements
                          specialRequirements={participant.Special_Requirements}
                        />
                      )}
                    </small>
                    <br />
                    <span className='smallprint'>
                      (
                      <Moment format='Y [year], M [months]' durationFromNow ago>
                        {participant.Date_Of_Birth}
                      </Moment>{" "}
                      old)
                    </span>
                  </td>
                  <td className='align-self-center align-middle'>
                    <Button
                      variant='info'
                      size='sm'
                      as={Link}
                      to={`/admin/customer-list/${participant.SystemUserID}`}
                      type='link'
                    >
                      Info
                    </Button>
                  </td>
                  <td className='align-self-center align-middle'>
                    {participant._id !== cancellingID ? (
                      <Button
                        variant='warning'
                        size='sm'
                        type='button'
                        disabled={props.submitClicked}
                        onClick={() => setCancellingID(participant._id)}
                      >
                        Kick?
                      </Button>
                    ) : (
                      <>
                        <Button
                          variant='danger'
                          size='sm'
                          type='submit'
                          disabled={props.submitClicked}
                          onClick={(e) => cancelBooking(participant._id, e)}
                        >
                          Confirm
                        </Button>
                        <Button
                          variant='secondary'
                          className='ms-2'
                          size='sm'
                          type='button'
                          disabled={props.submitClicked}
                          onClick={() => setCancellingID("")}
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          <p>No Subscribers yet...</p>
        )}
      </Col>
    </Row>
  );
};

export default BlockParticipants;
